module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/3S9DWU/tc-custom/9781488078309.jpg?1726574150416",
      "alt": "This image is the cover for the book Fatal Pursuit, K-9 Unit"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Fatal Pursuit, K-9 Unit\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Two thrilling stories from the True Blue K-9 Unit series.")]), _c('b', [_c('i', [_c('br'), _c('br')])]), _vm._v("Seeking the Truth by Terri Reed"), _c('br'), _c('br'), _vm._v("By secretly investigating the New York City K-9 Command Unit chief’s murder, reporter Rachelle Clark puts a bull’s-eye on her back. Single dad and K-9 unit officer Carter Jameson thought Rachelle was reporting on police-field-dog trials—not his brother’s death. Though he’s not happy about her true purpose, the danger is real…and he and his trusty German shepherd must save her."), _c('br'), _c('br'), _c('b', [_c('i', [_vm._v("Trail of Danger")])]), _c('b', [_c('i')]), _c('b', [_vm._v("by Valerie Hansen"), _c('br'), _c('br')]), _vm._v("Injured by an attack she can’t remember, Abigail Jones knows someone’s after her, but she doesn’t know why or who. Now the man who rescued her, Officer Reed Branson, and his K-9 partner will shield her while she regains her memory. But unraveling the mystery surrounding Abigail leads to more questions than answers…and to a ruthless enemy who’s determined to take their lives."), _c('br'), _c('br'), _vm._v("USA TODAY Bestselling Author Valerie Hansen\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Terri Reed, Valerie Hansen\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0